<!-- mettal-3\src\components\View702.vue -->
<template>
  <div class="view-197">
    <p class="x01-28 poppins-semi-bold-white-16px">
      {{ x01 }}
    </p>
    <div class="text-24-3">
      <svg 
        width="23" 
        height="19" 
        viewBox="0 0 23 19" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M21.1719 0.789062C21.875 0.75 22.5 1.29688 22.4609 1.96094V15.1641C22.4609 15.7891 21.9531 16.3359 21.2891 16.375C19.375 16.4531 15.4688 16.8438 12.7734 18.2109C12.3438 18.4062 11.8359 18.1328 11.8359 17.6641V3.44531C11.8359 3.25 11.9531 3.05469 12.1484 2.9375C14.7656 1.33594 19.0234 0.90625 21.1719 0.789062ZM10.3125 2.9375C10.5078 3.05469 10.625 3.25 10.625 3.44531V17.6641C10.625 18.1328 10.1172 18.4062 9.6875 18.2109C6.99219 16.8438 3.08594 16.4531 1.17188 16.375C0.507812 16.3359 0 15.7891 0 15.1641V1.96094C0 1.29688 0.585938 0.75 1.28906 0.789062C3.4375 0.90625 7.69531 1.33594 10.3125 2.9375Z" 
          fill="white" 
          fill-opacity="0.7"
        />
      </svg>      
    </div>
  </div>
</template>

<script>
export default {
  name: "View702",
  props: ["x01"],
};
</script>

<style>
.view-197,
.view-198 {
  height: 72px;
  left: 25px;
  position: absolute;
  top: 10px;
  width: 247px;
}

.text-24-2,
.text-29 {
  left: 0;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 54px;
}

.x01-28,
.x01-29,
.x01-30,
.x01-31,
.x01-32,
.x01-33,
.x01-34 {
  left: 38px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 0;
  width: 203px;
}

.text-24-3,
.text-40-1 {
  left: 0;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 4px;
  white-space: nowrap;
}
</style>
